module.exports = __webpack_public_path__ + "assets/img/modal-avatar-6cf73077.png";